import PropTypes from "prop-types";
import styles from "./index.css";
import content from "app-content";
import classnames from "classnames";

const CloseButton = ({ onClick, className }) => (
  <button
    className={classnames(styles.closeButton, className)}
    onClick={onClick}
    aria-label={content.saved_items_accessibility_close}
  />
);

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default CloseButton;
